export { default } from './SocialShare';